import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { MdKeyboardArrowRight } from "react-icons/md";
import HeaderMenu from "../component/Navbar/headermenu";
import CustomFooter from "../component/Footer/customFooter";

const ContactSupport = () => {
  return (
    <>
      <Helmet>
        <title>Contact Support - Simplifyte</title>

        {/* Open Graph meta */}
        <meta property="og:title" content="Contact Support - Simplifyte" />
        <meta
          name="description"
          property="og:description"
          content="We are here to help. Ask product questions, report problems, or leave feedback."
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.simplifyte.com/contactsupport"
        />

        {/* Viewport for responsive design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Simplifyte support, customer support, product help, report issue, leave feedback, support team, technical support"
        />
      </Helmet>
      <HeaderMenu />
      <section className="contact-support-page py-36">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className=" mb-95 ">
                <div>
                  <div className="row-direction">
                    <div className="direction-columns">
                      <div className="support-text">
                        <div className="box-main-content documentation contact-support-documentation">
                          {/* Contactsupport_Heading */}
                          <h1 className="Contactsupport_Heading">
                            Contact support
                          </h1>
                          <p className="content-desc width-adjust text-slate-400 mt-4 c-c-width">
                            We are here to help. Ask product questions, report
                            problems, or leave feedback.
                          </p>
                        </div>
                      </div>
                      <div className="support-text">
                        <div className="box-main-content join-comm text-slate-400 mt-6 c-c-width">
                          <p className="content-desc width-adjust">
                            Questions about our plans, pricing, or request a
                            demo?
                          </p>
                          <div className="mt-4">
                            <p className="text-slate-400 max-w-xl">
                              Technical issues or product questions?
                            </p>
                            <Link
                              to="/contactsales"
                              className="relative inline-flex items-center font-semibold tracking-wide align-middle text-base text-center border-none after:content-[''] after:absolute after:h-px after:w-0 hover:after:w-full after:end-0 hover:after:end-auto after:bottom-0 after:start-0 after:duration-500 text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500"
                            >
                              Talk To Sales{" "}
                              <MdKeyboardArrowRight className="text-xl" />
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="support-text">
                        <div className="box-main-content documentation">
                          <p className="content-desc width-adjust text-slate-400 mt-6 c-c-width">
                            Get an overview of Simplifyte's features,
                            integrations, and how to use them.
                          </p>
                          <div className="mt-4">
                            <p className="text-slate-400 max-w-xl">
                              Technical issues or product questions?
                            </p>
                            <Link
                              to="/docs"
                              className="relative inline-flex items-center font-semibold tracking-wide align-middle text-base text-center border-none after:content-[''] after:absolute after:h-px after:w-0 hover:after:w-full after:end-0 hover:after:end-auto after:bottom-0 after:start-0 after:duration-500 text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500"
                            >
                              Visit Docs{" "}
                              <MdKeyboardArrowRight className="text-xl" />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="direction-columns mb-8">
                      <div className="login-simplifyte-acc">
                        <div className="box-main-content general-comm mt-10">
                          <p className="content-desc mb-0">
                            Log in to your Simplifyte account so we can help you
                            faster:
                          </p>
                          <a
                            className="custom-header-btn login-btn other-css"
                            href="https://app.simplifyte.com/login"
                          >
                            Log in
                          </a>
                          <p className="content-desc mb-0">
                            span or email us at{" "}
                            <a
                              href="mailto:support@simplifyte.com"
                              target="_blank"
                              className="relative inline-flex items-center font-semibold tracking-wide
                                text-base text-center border-none after:content-[''] after:absolute after:h-px after:w-0 hover:after:w-full after:end-0 hover:after:end-auto after:bottom-0 after:start-0 after:duration-500 text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500"
                            >
                              {/* align-middle */}
                              support@simplifyte.com
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CustomFooter />
    </>
  );
};

export default ContactSupport;
